import axios from 'axios'
import * as types from '../mutation-types'

import { createTheParametersOfTheUrl } from '../../plugins/helper'

// state
export const state = {
  loadingFlatDetails: true,
  flatDetails: [],
  errorFlatDetails: {},
}

// mutations
export const mutations = {
  [types.GET_FLAT_DETAILDS_START] (state) {
    state.loadingFlatDetails = true
    state.flatDetails = []
    state.errorFlatDetails = {}
  },

  [types.GET_FLAT_DETAILDS_SUCCESS] (state, { data }) {
    state.loadingFlatDetails = false
    state.flatDetails = data
    state.errorFlatDetails = {}
  },

  [types.GET_FLAT_DETAILDS_ERROR] (state, { error }) {
    state.loadingFlatDetails = false
    state.flatDetails = []
    state.errorFlatDetails = error
  },
}

export const actions = {
  async getFlatDetailds ({ commit }, payload) {
    try {
      commit(types.GET_FLAT_DETAILDS_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/permission/detalles_plano${href}`)

      commit(types.GET_FLAT_DETAILDS_SUCCESS, { data })
    } catch (e) {
      const { response } = e
      commit(types.GET_FLAT_DETAILDS_ERROR, { error: response })
    }
  },
}

// getters
export const getters = {
  loadingFlatDetails: state => state.loadingFlatDetails,
  flatDetails: state => state.flatDetails,
  errorFlatDetails: state => state.errorFlatDetails,
}
